import { createContainer } from 'react-sweet-state';

import {
  type Actions,
  type ContainerProps,
  PRIVATE_ACTIONS,
  SavedDocumentViewStore,
  type State,
} from './SavedDocumentViewStore';

export const SavedDocumentViewStoreContainer = createContainer<State, Actions, ContainerProps>(
  SavedDocumentViewStore,
  {
    onInit:
      () =>
      ({ dispatch }) => {
        dispatch(PRIVATE_ACTIONS.init());
      },
  }
);
